/**
 * Wait for images to resolve then return image.
 * Thanks to Kimbatt https://stackoverflow.com/a/56341485
 * @param {String[]} imageURLs array of image url strings
 * @return {Image[]} array of Image objects or empty array if all images did not load
 */
const loadImages = async (imageURLs) => {
  const promises = [];
  const images = [];

  for (const imageURL of imageURLs) {
    promises.push(new Promise((resolve) => {
      const img = new Image();

      img.onload = function() {
        resolve();
      };

      img.src = imageURL;
      images.push(img);
    }));
  }

  await Promise.all(promises);
  if (images.length != imageURLs.length) {
    console.error(`Error: images loaded (${images.length}) != imageURls (${imageURLs.length})`);
    return [];
  }
  return images;
};

/**
 * parse the innerHTMLString to find the URL from the `<img>` tags
 * Thanks to MikeM and norman784 https://stackoverflow.com/a/15013465
 * @param {String} innerHTMLString HTML string that should contain `<img>` tags
 * @return {String[]} array of image URL strings
 */
const parseImageURL = (innerHTMLString) => {
  let temp;
  const urls = [];
  const regex = /<img.*?src="([^">]*\/([^">]*?))".*?>/g;

  while (temp = regex.exec(innerHTMLString)) {
    urls.push(temp[1]);
  }
  return urls;
};

export {
  loadImages,
  parseImageURL,
};
